import { MailSend01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Head, useForm } from "@inertiajs/react";
import type { FormEvent } from "react";
import Dashboard from "@/components/dashboard";
import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import {
	Field,
	FieldDescription,
	FieldGroup,
	FieldLabel,
} from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import type HomeUser from "@/types/serializers/HomeUser";

interface Props {
	user: HomeUser;
	errors?: Record<string, string[]>;
}

export default function New({ user, errors }: Props) {
	const { data, setData, post, processing, reset } = useForm({
		email: "",
	});

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();
		post("/invitation", {
			onSuccess: () => reset(),
		});
	};

	return (
		<>
			<Head title="Pozvat uživatele" />
			<Dashboard user={user}>
				<div className="flex flex-1 flex-col gap-6 p-4 lg:p-6">
					<div className="flex items-center gap-3">
						<div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
							<HugeiconsIcon
								icon={MailSend01Icon}
								strokeWidth={2}
								className="size-5 text-primary"
							/>
						</div>
						<div>
							<h2 className="font-semibold text-2xl">Pozvat uživatele</h2>
							<p className="text-muted-foreground text-sm">
								Pozvěte nového uživatele do vaší organizace
							</p>
						</div>
					</div>

					<Card>
						<CardHeader>
							<CardTitle>Pozvánka</CardTitle>
							<CardDescription>
								Zadejte e-mailovou adresu uživatele, kterého chcete pozvat. Bude
								mu zaslán e-mail s instrukcemi pro nastavení účtu.
							</CardDescription>
						</CardHeader>
						<CardContent>
							<form onSubmit={handleSubmit}>
								<FieldGroup>
									<Field>
										<FieldLabel htmlFor="email">E-mail</FieldLabel>
										<Input
											id="email"
											name="email"
											type="email"
											placeholder="jan.novak@example.com"
											value={data.email}
											onChange={(e) => setData("email", e.target.value)}
											aria-invalid={!!errors?.email}
											required
											autoComplete="email"
										/>
										{errors?.email && (
											<FieldDescription className="text-destructive">
												{errors.email.join(", ")}
											</FieldDescription>
										)}
									</Field>

									<Field>
										<Button type="submit" disabled={processing}>
											<HugeiconsIcon
												icon={MailSend01Icon}
												strokeWidth={2}
												className="size-4"
											/>
											Odeslat pozvánku
										</Button>
									</Field>
								</FieldGroup>
							</form>
						</CardContent>
					</Card>

					<p className="text-muted-foreground text-xs">
						Pozvaný uživatel obdrží e-mail s odkazem pro nastavení hesla a bude
						automaticky přidán do vaší organizace.
					</p>
				</div>
			</Dashboard>
		</>
	);
}
